import { Box, Typography } from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GvSecondaryButton from "../../../components/GvSecondaryButton/GvSecondaryButton";
import { getApptTypeLabel } from "../../../components/Appointments/AppointmentCard";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import React from "react";
import { StyledBookingFlowButton } from "../BookingScheduleContainer/BookingScheduleContainer.style";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useModal } from "../../../context/ModalContext";
import { userActivityLogger } from "../../../utils/mixpanel";
import { useBookingAppointmentTypeStore, useBookingReasonsNavigation } from "../../../hooks";
import { useUrgentVisitStore } from "../../../hooks/redux-hooks/urgent-visit-store/urgent-visit.store";

const CancelAppointmentConfirmation = () => {
  const { openModal, closeModal, setAppointmentErrorCode } = useModal();
  const { setSelectedPets, setReasonForVisit, setAppointmentsForm, setPromoCodeData, resetCurrentBookingStep } =
    useAppointmentStore();
  const { setDefaultBookingType, bookingAppointmentType } = useBookingAppointmentTypeStore();
  const { resetReasonsNavigationStore }=useBookingReasonsNavigation();
  const { resetUrgentVisit } = useUrgentVisitStore();

  const getAppointmentCategory = () => {
    switch (bookingAppointmentType) {
    case CREATE_BOOKING_TYPE.URGENT_BOOKING: return "urgent";
    case CREATE_BOOKING_TYPE.EXPRESS_BOOKING: return "tech";
    case CREATE_BOOKING_TYPE.DROPOFF_BOOKING: return "drop_off";
    default: return "dvm";
    }
  };

  const handleRedirectBooking = () => {
    userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_RESUME, {
      appointment_category: getAppointmentCategory(),
      appt_type: getApptTypeLabel(bookingAppointmentType),
    });
    switch (bookingAppointmentType) {
    case CREATE_BOOKING_TYPE.EXPRESS_BOOKING:
      openModal(MODALS.EXPRESS_VISIT_MODAL);
      break;
    case CREATE_BOOKING_TYPE.URGENT_BOOKING:
      openModal(MODALS.URGENT_VISIT_MODAL);
      break;
    default:
      openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
      break;
    }
  };
  const handleExitBooking = () => {
    setDefaultBookingType();
    userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_EXIT, {
      appointment_category: getAppointmentCategory(),
      appt_type: getApptTypeLabel(bookingAppointmentType),
    });
    setAppointmentErrorCode("");
    setSelectedPets([]);
    setAppointmentsForm(null);
    resetReasonsNavigationStore();
    setReasonForVisit({});
    setPromoCodeData([]);
    resetCurrentBookingStep();
    if (bookingAppointmentType === CREATE_BOOKING_TYPE.URGENT_BOOKING) {
      resetUrgentVisit();
    }
    closeModal();
  };

  return (
    <>
      <Box className="p-1">
        <ArrowBackIcon
          onClick={handleRedirectBooking}
          className="text-light-black cursor-pointer"
        />
      </Box>
      <Box className="flex flex-col justify-center items-center grow shrink gap-2">
        <img src="/assets/icons/exitBookingImage.png" className="h-24 w-32" />
        <Typography variant="h2" className="!font-bold !text-2xl text-center">
          Exit Book Appointment?
        </Typography>
        <Typography className="text-light-black text-center text-sm">
          Are you sure you want to exit booking? <br />
          Your progress will not be saved.
        </Typography>
      </Box>
      <Box className="sticky bottom-0 flex flex-col gap-3">
        <StyledBookingFlowButton
          fullWidth
          color="primary"
          size="small"
          onClick={handleExitBooking}
        >
          Exit Booking
        </StyledBookingFlowButton>
        <GvSecondaryButton
          type={"button"}
          className="!font-bold !border-gray-2 !h-[2.4rem]"
          onClick={handleRedirectBooking}
        >
          Resume
        </GvSecondaryButton>
      </Box>
    </>
  );
};

export default CancelAppointmentConfirmation;
